import useInfiniteService from '@/data/hook/useInfiniteService';
import { lessonsQueryKeys } from '@/data/services/querykeys';
import { useLessonsBlockWithLessons } from './courses/studio/CourseStudio.hooks';

const useLessons = (slugCourseName: string) => {
  const {
    lessonBlocksWithLessons,
    lessons,
    invalidateBlock,
    isLoading: isLoadingLessonsBlock,
    invalidate: invalidateLessonsBlock,
    fetchNextPage: fetchNextPageLessonsBlock,
    hasNextPage: hasNextPageLessonsBlock,
    isFetchingNextPage: isFetchingNextPageLessonsBlock,
  } = useLessonsBlockWithLessons(slugCourseName);
  const { queryKey, queryFn } = lessonsQueryKeys.nestedList(slugCourseName, {
    pageSize: 50,
  })._ctx.infinity;

  const {
    results: directLessons,
    isInitialLoading: isLoadingLessons,
    hasNextPage: hasNextPageLessons,
    isFetchingNextPage: isFetchingNextPageLessons,
    fetchNextPage: fetchNextPageLessons,
    invalidate,
  } = useInfiniteService({
    queryKey,
    queryFn,
    keepPreviousData: true,
    enabled: !!slugCourseName && lessonBlocksWithLessons.length === 0,
  });

  const updateLessons = async () => {
    await invalidate();
    await invalidateLessonsBlock();
  };

  const fetchNextPage = async () => {
    await fetchNextPageLessons();
    await fetchNextPageLessonsBlock();
  };

  const isFetchingNextPage =
    isFetchingNextPageLessons || isFetchingNextPageLessonsBlock;

  const hasNextPage = hasNextPageLessons || hasNextPageLessonsBlock;

  const isLoading = isLoadingLessons || isLoadingLessonsBlock;
  return {
    lessons: [...lessons, ...directLessons],
    directLessons: lessonBlocksWithLessons.length > 0 ? [] : directLessons,
    lessonBlocksWithLessons,
    isLoading,
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
    updateLessons,
    invalidateBlock,
  };
};

export default useLessons;
